export default __webpack_public_path__ + "static/media/empty.0a0b3d1b.svg";